import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import { Twitter } from "@material-ui/icons";
// import FacebookIcon from "@material-ui/icons/Facebook";
// import DescriptionIcon from "@material-ui/icons/Description";
// import PublicIcon from "@material-ui/icons/Public";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
export const About = () => {
  return (
    <>
      <div className="about center">
        <h1 data-aos="fade-right">
       <span className="about__name"><h1 align="left" >Hey<img src="https://media.tenor.com/SNL9_xhZl9oAAAAj/waving-hand-joypixels.gifhttps://media.tenor.com/SNL9_xhZl9oAAAAj/waving-hand-joypixels.gif" width="60" />, I'm</h1>Md Talib Ansari</span>
        </h1>
        <Type />
        <p className="about__desc" data-aos="fade-right">
        “ It's not all about how you work hard but it's about how you manage your time, resources. 
        And Success isn’t always about greatness. It’s about consistency. Consistent hard work leads to success. 
        Greatness will come. ”
          {/* A Full Stack Developer who loves solving problems and building
          projects. I am equipped with a variety of technologies and tools to
          help me build the best possible product. */}
        </p>
        <div className="about__contact center">
          <a
            href="https://github.com/talib789"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:mdtalibansari55048@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
          <a
            href="tel:+918340595343"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <PhoneIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/md-talib-ansari-117483213/"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://twitter.com/MdTalib57200313"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <Twitter />
          </a>
          {/* <a
            href=""
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a>
          <a
            href=""
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <PublicIcon />
          </a> */}
        </div>
      </div>
      <Introduction />
      <Timeline />
      <section id="#skills">
        <Techstacks />
      </section>
    </>
  );
};
